import * as React from 'react'

import { Grid, GridItem } from '@thg-commerce/gravity-system'

import { MacroInputForm } from './MacroInputForm'
import { MacroResults } from './MacroResults'
import { Macros } from './types'

export const MacroCalculator = () => {
  const [macros, setMacros] = React.useState<Macros>({
    fat: 0,
    protein: 0,
    carbohydrate: 0,
  })

  const [showResultsView, setShowResultsView] = React.useState<boolean>(false)

  return (
    <Grid aria-live="polite">
      <GridItem colSpan={12} colStart={1} rowStart={1}>
        {showResultsView ? (
          <MacroResults
            macros={macros}
            buttonLink={
              'https://www.myprotein.com/nutrition/weight-management/weight-loss-supplements.list'
            }
            setShowResultsView={setShowResultsView}
          />
        ) : (
          <MacroInputForm
            setMacros={setMacros}
            setShowResultsView={setShowResultsView}
          />
        )}
      </GridItem>
    </Grid>
  )
}
